import React, { Component } from 'react';
import SCountdownTimer from 'shared/lib/time/component/CountdownTimer';

import TimeRemainingText from '../../../components/TimeRemainingText';
import ImageBW from '../../../components/ImageBoundsWrapper';

const TIMER_BACKGROUND = {
  green: require(asset`Purple_Timer@3x.png`),
  yellow: require(asset`Orange_Timer@3x.png`),
  red: require(asset`Red_Timer@3x.png`),
};
export default class CountdownTimer extends Component {
  render() {
    return (
      <SCountdownTimer
        navigation={this.props.navigation}
        endDate={this.props.endDate}
        justTimerText={this.props.justTimerText}
        render={({ timerBackgroundColor }) => {
          return (
            <>
              {!this.props.justTimerText ? (
                <ImageBW
                  source={TIMER_BACKGROUND[timerBackgroundColor]}
                  ibw={require(asset`Timer.ibw`)}
                  style={{
                    height: '1.7rem',
                    width: '80%',
                    padding: 0,
                    margin: 0,
                    top: '1.9rem',
                    left: '1.1rem',
                    zIndex: -1,
                  }}
                  innerStyle={{
                    width: '100%',
                    padding: 0,
                    margin: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <ImageBW
                    source={require(asset`Clock_Icon@3x.png`)}
                    ibw={require(asset`Clock_Icon.ibw`)}
                    style={{
                      height: 18,
                      width: 18,
                      margin: 0,
                      marginRight: 2,
                    }}
                    innerStyle={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  />
                  <TimeRemainingText
                    style={{
                      fontSize: '14px',
                      margin: 0,
                      fontWeight: 400,
                      opacity: 0.7,
                      marginLeft: 2,
                    }}
                    until={this.props.endDate}
                    counterType={this.props.counterType}
                  />
                </ImageBW>
              ) : (
                <TimeRemainingText
                  style={
                    this.props.style
                      ? this.props.style
                      : {
                          fontSize: '14px',
                          margin: 0,
                          fontWeight: 400,
                          opacity: 0.7,
                          marginLeft: 2,
                        }
                  }
                  until={this.props.endDate}
                  counterType={this.props.counterType}
                  endTimerCallback={this.props.endTimerCallback}
                />
              )}
            </>
          );
        }}
      />
    );
  }
}
